import React from 'react';
import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux"


const MentionLegales = (props) => {

    return (
        <main className="container">
            <section className="section-prods">

                <h2>Mentions légales</h2>
                <hr />

                <h3>1 – Édition du site</h3>
                <p>En vertu de l’article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l’économie numérique, il est précisé aux utilisateurs
                    du site internet <a href="http://www.Court-Jus.fr">www.Court-Jus.fr</a> l’identité des différents intervenants dans le cadre de sa réalisation et de son suivi:</p>
                <ul>
                    <li><span style={{ fontSize: "0.8rem" }}>Propriétaire du site : CourtJus</span></li>
                    <li><span style={{ fontSize: "0.8rem" }}>Contact : <a href="mailto:court.jus.asso@gmail.com">court.jus.asso@gmail.com</a></span></li>
                    <li><span style={{ fontSize: "0.8rem" }}>Hébergeurs : OVH <a href="https://www.ovhcloud.com/fr/">https://ovhcloud.com</a> &nbsp;
                        et Always Data <a href="https://www.alwaysdata.com/fr/">https://www.alwaysdata.com</a></span></li>

                    <li><span style={{ fontSize: "0.8rem" }}>Propriétaire de l'application : AWA 05</span></li>
                    <li><span style={{ fontSize: "0.8rem" }}>Contact : <a href="mailto:contact@awa05.ovh">contact@awa05.ovh</a></span></li>
                </ul>

                <h3>2 – Propriété intellectuelle et contrefaçons</h3>
                <p>Fabrice Reymond est propriétaire des droits de propriété intellectuelle de l'application. Toute reproduction, représentation, modification, publication,
                    adaptation de tout ou partie de l'application, quel que soit le moyen ou le procédé utilisé, est interdite,
                    sauf autorisation écrite préalable de Fabrice Reymond.</p>
                <p>Court Jus détient les droits d’usage sur tous les éléments accessibles sur le site internet,
                    notamment les textes, images, graphismes, logos, vidéos, icônes et sons. Toute reproduction, représentation, modification, publication,
                    adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite,
                    sauf autorisation écrite préalable de Court Jus.</p>

                <h3>3 – Limitations de responsabilité</h3>
                <p>CourtJus ne pourra être tenu pour responsable des dommages directs et indirects causés au matériel de l’utilisateur,
                    lors de l’accès au site <a href="http://www.Court-Jus.fr">www.Court-Jus.fr</a>.
                    Court Jus décline toute responsabilité quant à l’utilisation qui pourrait être faite des informations
                    et contenus présents sur <a href="http://www.Court-Jus.fr">www.Court-Jus.fr</a>.</p>

                <h3>4 – CNIL et gestion des données personnelles</h3>
                <p>Conformément aux dispositions de la loi 78-17 du 6 janvier 1978 modifiée, l’utilisateur du site <a href="http://www.Court-Jus.fr">www.Court-Jus.fr</a>
                    dispose d’un droit d’accès, de modification et de suppression des informations collectées. Il est également possible de déposer une réclamation auprès de la CNIL.</p>

                <h3>5 – Liens hypertextes et cookies</h3>
                <p>Le site <a href="http://www.Court-Jus.fr">www.Court-Jus.fr</a> contient des liens hypertextes vers d’autres sites et dégage toute responsabilité à propos de ces liens externes
                    ou des liens créés par d’autres sites vers <a href="http://www.Court-Jus.fr">www.Court-Jus.fr</a>.
                    La navigation sur le site <a href="http://www.Court-Jus.fr">www.Court-Jus.fr</a> est susceptible de provoquer l’installation de cookie(s) sur l’ordinateur de l’utilisateur.</p>

                <h3>6 – Droit applicable et attribution de juridiction</h3>
                <p>Tout litige en relation avec l’utilisation du site <a href="http://www.Court-Jus.fr">www.Court-Jus.fr</a> est soumis au droit français.
                    En dehors des cas où la loi ne le permet pas, il est fait attribution exclusive de juridiction aux tribunaux compétents de Gap.</p>

            </section>
        </main>
    )
}

export default MentionLegales;